// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2607":"bdc5a04b","4898":"0774fd73","7306":"c4f2ea12"}[chunkId] + ".chunk.css";
};